module.exports = {"510422100":"桐子林镇","510422101":"红格镇","510422102":"渔门镇","510422103":"永兴镇","510422104":"新九镇","510422105":"惠民镇","510422203":"红果彝族乡","510422205":"共和乡","510422206":"国胜乡","510422207":"红宝苗族彝族乡","510422210":"温泉彝族乡","510422211":"格萨拉彝族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510422.json
// module id = 2415
// module chunks = 0